/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CRSFSecReviewTechSourceType = {
    Firehose: 'firehose',
    Asm: 'asm'
} as const;
export type CRSFSecReviewTechSourceType = typeof CRSFSecReviewTechSourceType[keyof typeof CRSFSecReviewTechSourceType];


export function CRSFSecReviewTechSourceTypeFromJSON(json: any): CRSFSecReviewTechSourceType {
    return CRSFSecReviewTechSourceTypeFromJSONTyped(json, false);
}

export function CRSFSecReviewTechSourceTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewTechSourceType {
    return json as CRSFSecReviewTechSourceType;
}

export function CRSFSecReviewTechSourceTypeToJSON(value?: CRSFSecReviewTechSourceType | null): any {
    return value as any;
}

